import { render, staticRenderFns } from "./UnregisteredNotificationsTable.vue?vue&type=template&id=645f977f"
import script from "./UnregisteredNotificationsTable.vue?vue&type=script&lang=js"
export * from "./UnregisteredNotificationsTable.vue?vue&type=script&lang=js"
import style0 from "./UnregisteredNotificationsTable.vue?vue&type=style&index=0&id=645f977f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports